import React from 'react';
import { Helmet } from 'react-helmet-async';
import { defaultSEO } from '../../config/seo';

const SEO = ({ title, description, keywords, canonicalUrl }) => {
    const seo = {
        title: title ? `${title} | VitAnimal` : defaultSEO.title,
        description: description || defaultSEO.description,
        keywords: keywords ? [...keywords, ...defaultSEO.keywords].join(', ') : defaultSEO.keywords.join(', '),
        canonicalUrl: canonicalUrl || defaultSEO.canonicalUrl,
    };

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="keywords" content={seo.keywords} />
            <link rel="canonical" href={seo.canonicalUrl} />

            {/* OpenGraph tags (for Facebook, LinkedIn, etc.) */}
            <meta property="route" content="/" />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={seo.canonicalUrl} />
            <meta property="og:site_name" content="VitAnimal" />

            {/* Twitter tags */}
            <meta name="twitter:creator" content={defaultSEO.author} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:description" content={seo.description} />
        </Helmet>
    );
}

export default SEO;
